import { ChangeDetectionStrategy, Component, Input} from '@angular/core';

export interface IInfoPanelDataItem {
  header: string;
  formattedValue: string;
}

@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoPanelComponent {
  @Input() title: string = null;
  @Input() data: IInfoPanelDataItem[] = null;
  @Input() footNote: string = null;
}
